import React, { Component, Fragment } from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import {
	Button,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Form,
	FormGroup,
	FormInput,
	FormSelect,
	InputGroup,
	InputGroupAddon,
} from 'shards-react';
import { addComplaintTypes, deleteItem } from '../adminActions';

const mapState = (state) => ({
	user: state.firebase.profile,
	dbsectors: state.firebase.ordered.sectors,
	complaintTypes: state.firebase.ordered.complaintTypes,
});

const actions = {
	deleteItem,
	addComplaintTypes,
};

class AddComplaintTypes extends Component {
	state = {
		sector: '',
		category: '',
		input: '',
	};

	handleSector = async (e) => {
		e.preventDefault();
		console.log(e.target.value);
		this.setState({ [e.target.name]: e.target.value });
		//this.props.firestore.get({ collection: 'sectors', doc: e.target.value, storeAs: 'queried' });
		//	console.log(this.props.sectors);
	};

	render() {
		const handleChange = (e) => {
			this.setState({ [e.target.name]: e.target.value.toLowerCase() });
		};
		const handleSubmit = (e) => {
			e.preventDefault();

			let complaintType = {
				sector: this.state.sector,
				name: this.state.input,
			};

			this.props.addComplaintTypes(complaintType);

			this.setState({ input: '' });
		};

		const { dbsectors, complaintTypes, deleteItem } = this.props;
		return (
			<Card>
				<CardHeader className="bg-primary1 text-white">Complaint Types</CardHeader>
				<CardBody className="category-list">
					{complaintTypes &&
						complaintTypes.map((type) => {
							return (
								<div key={type.key} className="text-capitalize w-100 caption">
									{type.value.sector} - {type.value.name}
									<MdClose
										className="float-right text-danger"
										onClick={() => deleteItem('complaintTypes/', type.key)}
									/>
								</div>
							);
						})}
				</CardBody>
				<CardFooter className="border-top">
					<Form>
						<FormGroup>
							<label htmlFor="username">Select Sector</label>
							<FormSelect name="sector" onChange={(e) => this.handleSector(e)} value={this.state.sector}>
								<option key="0" value="" />
								{dbsectors &&
									dbsectors.map((sector) => (
										<Fragment>
											<option key={sector.key} value={sector.value}>
												{sector.value}
											</option>
										</Fragment>
									))}
							</FormSelect>
						</FormGroup>

						<FormGroup>
							<InputGroup>
								<FormInput
									name="input"
									placeholder="Type a subsector here"
									onChange={handleChange}
									value={this.state.input}
								/>
								<InputGroupAddon type="append">
									<Button theme="success" onClick={handleSubmit} disabled={this.state.sector === ''}>
										Submit
									</Button>
								</InputGroupAddon>
							</InputGroup>
						</FormGroup>
					</Form>
				</CardFooter>
			</Card>
		);
	}
}

export default compose(
	connect(mapState, actions),
	firebaseConnect([ { path: '/complaintTypes', queryParams: [ 'orderByChild=sector' ], storeAs: 'complaintTypes' } ])
)(AddComplaintTypes);
